import axiosInstance from "../libs/axiosInstance";



// Get all faculties
export const getQuestionBankQuestions = async (topicId) => {
  try {
    const response = await axiosInstance.get(`/question_bank/question-bank/${topicId}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching questions:', error);
    throw error;
  }
};